import React from 'react'

import { AddUserIcon } from 'components/Utils/Icons'
import ModalLink from 'components/Utils/Modal/Link'
import { INVITE_OAUTH_MEMBERS } from 'components/Utils/Modal/constants'
import Button from 'components/base/Button'

const MIN_TEAM_SIZE = 3

export default ({ usersCount, canInvite }) => {
  if (usersCount >= MIN_TEAM_SIZE || !canInvite) {
    return false
  }

  return (
    <ModalLink
      className="flexbox"
      to={INVITE_OAUTH_MEMBERS}
      analytics={{
        type: 'INVITE_FROM_TOPBAR',
      }}
    >
      <Button.Secondary
        slim
        className="flexbox flexbox-no-shrink flexbox-align-center margin-right-small"
      >
        <AddUserIcon className="margin-right-small" />
        <span className="no-wrap">Add people</span>
      </Button.Secondary>
    </ModalLink>
  )
}
